import { HttpClient, HttpHeaders } from "@angular/common/http";
import { authData, saveAuth } from "src/app/util/auth";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { DataService } from "src/app/http/data.service";

@Component({
  selector: "app-student-info-header",
  templateUrl: "./student-info-header.component.html",
})
export class StudentInfoHeaderComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router, private dataService: DataService) {}

  _auth = authData();
  _courses = authData("_courses");
  _checks = authData("_checks");
  _isApplication = authData("_isApplication");

  items = [
    {
      title: "Class",
      value: this._auth?.Student?.Class,
    },
    {
      title: "Session",
      value: this._auth?.Session,
    }
  ];

  ngOnInit(): void {
    console.log(this._isApplication)
    if (Object.keys(this._checks).length === 0) {
      this.requirementData();
      this.fetchChecks();
      //this.refreshPayment();
    }
  }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${authData().Token}`,
    }),
  };

  clearMessage() {
    const _auth = authData();
    saveAuth({ ..._auth, NewMatricNumber: null });
    this._auth = authData();
  }

  fetchCourse() {
    const baseUrl = `${environment.BASE_URL}/courses/currentCourses`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => saveAuth(res?.Data || [], "_courses"),
      error: (err) => saveAuth([], "_courses"),
    });
  }

  fetchChecks() {
    this.dataService.fetchChecks(this._isApplication).subscribe({
      next: (res: any) => { if (res) saveAuth(res.Data, "_checks"); },
      error: (err) => saveAuth({}, "_checks"),
    });
  }
  accommodationChecks() {
    const baseUrl = `${environment.BASE_URL}/accomodation/accommodationChecks`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => saveAuth(res.Data, "_accommodation"),
      error: (err) => saveAuth({}, "_accommodation"),
    });
  }
  sliderData() {
    this.dataService.fetchSlider().subscribe({
      next: (res: any) => saveAuth(res.Data, "_slider"),
      error: (err) => saveAuth({}, "_slider"),
    });
  }
  requirementData() {
    const baseUrl = `${environment.BASE_URL}/users/requirements`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => saveAuth(res.Data, "_requirements"),
      error: (err) => saveAuth({}, "_requirements"),
    });
  }
  refreshPayment() {
    const baseUrl = `${environment.BASE_URL}/payments/refereshStatus`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe();
  }
}
